<mat-sidenav-container class="navbar-container">
    <mat-sidenav #sidenav [mode]="sidenavMode" [(opened)]="sidenavOpened" class="navbar-sidenav">
        <mat-nav-list class="navbar-items">
            @for (item of menuItems; track item.menuId) {
            <a [routerLink]="item['route']" class="navbar-item" routerLinkActive="active" #routerActive="routerLinkActive" [routerLinkActiveOptions]="{ exact: false }" (click)="toggleSidenav()">
                <span mat-list-item class="nav-element" tourAnchor="{{item['tourAnchorId']}}">
                            <ng-container *ngComponentOutlet="item['icon']"></ng-container>
                    <span class="nav-item-label">{{item['label']}}</span>
                </span>
            </a>
            }
        </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
        <div class="mat-sidenav-content">
            <router-outlet></router-outlet>
        </div>
            </mat-sidenav-content>
</mat-sidenav-container>
